// DOM checks behind the OMP editor's undo/redo shortcuts and step grouping.
import { OmpHistoryAction } from '../_models';

const TEXT_INPUT_TYPES = ['text', 'search', 'email', 'url', 'tel', 'number', 'password'];
const NATIVE_UNDO_SELECTOR = '[contenteditable="true"], .tox, .monaco-editor';
const DRAG_CONTROL_SELECTOR = 'input[type="range"], .csp-picker';

export function ompHistoryShortcut(event: KeyboardEvent): OmpHistoryAction {
  let action: OmpHistoryAction = null;
  const key = event.key ? event.key.toLowerCase() : '';
  if ((event.ctrlKey || event.metaKey) && !event.altKey) {
    if (key === 'z') {
      action = event.shiftKey ? OmpHistoryAction.Redo : OmpHistoryAction.Undo;
    } else if (key === 'y' && event.ctrlKey && !event.shiftKey) {
      action = OmpHistoryAction.Redo;
    }
  }
  return action;
}

export function ompKeepsNativeUndo(target: EventTarget): boolean {
  return target instanceof Element && !!target.closest(NATIVE_UNDO_SELECTOR);
}

export function ompIsTextField(target: EventTarget): boolean {
  let text = target instanceof HTMLTextAreaElement;
  if (target instanceof HTMLInputElement) {
    text = TEXT_INPUT_TYPES.indexOf(target.type) >= 0;
  }
  return text;
}

export function ompIsDragControl(target: EventTarget): boolean {
  return target instanceof Element && !!target.closest(DRAG_CONTROL_SELECTOR);
}
